import * as actions from '../actions/activityActions';

const initialState =  {
  activity: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_ACTIVITY:
      return {
        ...state,
        activity: action.payload || null
    };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/activityReducer.js